import xhr from 'xhr';

const display = (value) => {
  if (value === true) return 'Sí';
  if (value === false) return 'No';
  const text = value === null || value === undefined ? '' : String(value).trim();
  return text ? `"${text}"` : 'vacío';
};

const normalize = (value) => (value === null || value === undefined ? '' : String(value).trim());

/**
 * Compara los valores antes y después de guardar y devuelve los cambios con su
 * etiqueta legible. `fields` es un objeto { campo: 'Etiqueta' }.
 */
export const diffFields = (before, after, fields) =>
  Object.entries(fields)
    .filter(([name]) => normalize(before[name]) !== normalize(after[name]))
    .map(([name, label]) => ({ label, from: before[name], to: after[name] }));

/**
 * Deja en el historial del estudiante quién corrigió qué datos. Así
 * administración sabe qué cambió respecto al PDF de la ficha de matrícula,
 * que es una foto del momento en que el estudiante la envió.
 */
export async function logStudentChanges({ studentId, userId, section, changes, hideValues = false }) {
  if (!changes.length) return;

  const detail = changes
    .map((change) => (hideValues ? change.label : `${change.label}: ${display(change.from)} → ${display(change.to)}`))
    .join('; ');

  try {
    await xhr.post('/student-histories/', {
      data: { detail: `Datos corregidos (${section}). ${detail}`, student: studentId, user: userId },
    });
  } catch (error) {
    // El historial no debe impedir la corrección: el dato ya quedó guardado.
    console.error('No se pudo registrar el cambio en el historial', error);
  }
}
